import { useCallback, useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import StudioPage from './pages/StudioPage';
import VideoStudioPage from './pages/VideoStudioPage';
import VideoEditPage from './pages/VideoEditPage';
import AssetsPage from './pages/AssetsPage';
import Login from './pages/Login';
import Verify from './pages/Verify';
import { apiFetch, type AuthMe } from './lib/api';

type AuthState =
  | { kind: 'loading' }
  | { kind: 'signed-out' }
  | { kind: 'signed-in'; email: string };

export default function App() {
  const [auth, setAuth] = useState<AuthState>({ kind: 'loading' });

  // The SPA is "signed in" iff /api/auth/me returns 200. Any error (incl. 401)
  // → signed-out, which forces the login page.
  const refresh = useCallback(() => {
    apiFetch<AuthMe>('/api/auth/me')
      .then((me) => setAuth({ kind: 'signed-in', email: me.email }))
      .catch(() => setAuth({ kind: 'signed-out' }));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  if (auth.kind === 'loading') {
    return (
      <div className="login-shell">
        <div className="card login-card">
          <span className="spin" />
        </div>
      </div>
    );
  }

  if (auth.kind === 'signed-out') {
    return (
      <Routes>
        <Route path="/verify" element={<Verify onVerified={refresh} />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<StudioPage />} />
      <Route path="/video" element={<VideoStudioPage />} />
      <Route path="/video/edit/:name" element={<VideoEditPage />} />
      <Route path="/assets" element={<AssetsPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
